module.exports = __webpack_public_path__ + "static/link-6a2a12abf267662fa12b7e795103e1fb.png";